module.exports = __webpack_public_path__ + "static/media/golf.687ff10a.jpg";